import { StyledTableHead, StyledTableHeadCell } from '../../../styles/TableStyles'
import { Stack, TableRow, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import { HeaderCell } from '../../../store/types'
import React from 'react'

type ScheduleTableHeaderProps = {
  cells: HeaderCell[]
  stickyOffset?: number
}

const ScheduleTableHeader = ({ cells, stickyOffset }: ScheduleTableHeaderProps) => {
  const theme = useTheme()
  const isBetweenSmAndSmMid = useMediaQuery(theme.breakpoints.between('sm', 'smMid'))
  const isBetweenLgAndLgMid = useMediaQuery(theme.breakpoints.between('lg', 'lgMid'))
  const isMediumScreen = useMediaQuery(theme.breakpoints.down('md'))
  const pagePadding = parseFloat(theme.spacing(4)) || 0
  const fallbackTop = isMediumScreen ? 22 : 60
  const baseTop = stickyOffset && stickyOffset > 0 ? stickyOffset : fallbackTop
  const adjustedTop = Math.max(baseTop - pagePadding, 0)
  const computedTop = `${adjustedTop}px`

  return (
    <StyledTableHead sx={{ position: 'sticky', top: computedTop, zIndex: 90 }}>
      <TableRow>
        {cells?.map(c => (
          <StyledTableHeadCell component={c.title === '' ? 'td' : 'th'} align={c.align} width={c.width} key={c.id}>
            {c.fullTitle ? (
              isBetweenSmAndSmMid || isBetweenLgAndLgMid ? (
                <Tooltip
                  title={
                    <Stack alignItems={'center'}>
                      <Typography>{c.fullTitle}</Typography>
                    </Stack>
                  }
                >
                  <Typography>{c.title}</Typography>
                </Tooltip>
              ) : (
                <Typography>{c.fullTitle}</Typography>
              )
            ) : (
              <Typography>{c.title}</Typography>
            )}
          </StyledTableHeadCell>
        ))}
      </TableRow>
    </StyledTableHead>
  )
}

export default ScheduleTableHeader
